import Validator from 'validatorjs';
import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { IQuoteQuestion } from '../../classes/ExternalQuote';

Validator.registerImplicit('wrong_answer', function (this: any, value, requirement, attribute) {
    const question = this.validator.input as IQuoteQuestion;

    if (!question.anyAnswer && question.answer !== question.defaultValue) {
        return false;
    }
    return true;
});

interface LooseObject {
    [key: string]: any
}

const customErrorMessages = {
    "wrong_answer": "Sorry we can't continue with this answer to the question"
};

export const allFieldsValidation = (data) => {
    var rules: LooseObject = {};
    rules["answer_" + data.code] = ['required', 'wrong_answer'];

    var _data: LooseObject = {};
    _data["answer_" + data.code] = data.answer;
    _data.answer = data.answer;
    _data.anyAnswer = data.anyAnswer;
    _data.defaultValue = data.defaultValue;
    return allFieldsValidationCommon(_data, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};